<template>
    <div style="background-color: #EEEDED; height: 200px;line-height: 200px; text-align:center">
        <span style="font-size: 30px; margin: auto;">敬请期待...</span>
    </div>
</template>

<script>
  export default {
    name: "JingQingQiDai"
  }
</script>

<style scoped lang="less">
</style>
